import { Navigate, Outlet } from "react-router-dom";

import DashboardLayout from "../components/layout/DashboardLayout";
import { getUser } from "../services/auth";

const PrivateRoute = () => {
  const isAuthenticated = getUser();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <DashboardLayout />;
};

const PublicRoute = () => {
  const isAuthenticated = getUser();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export { PrivateRoute, PublicRoute };
